import React, { useEffect } from 'react';
import classNames from 'classnames/bind';
import styles from './Toast.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

const cx = classNames.bind(styles);

function Toast({ message, type = 'success', onClose, duration = 3000 }) {
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [message, duration, onClose]);

  if (!message) return null;

  return (
    <div className={cx('toast', type)}>
      <FontAwesomeIcon
        icon={type === 'success' ? faCheckCircle : faExclamationCircle}
        className={cx('toast-icon')}
      />
      <span className={cx('toast-message')}>{message}</span>
    </div>
  );
}

export default Toast;